export class SilentCustomRequestError extends Error {
    constructor(message) {
        super(message)

        this.name = 'SilentCustomRequestError'
    }
}
